module.exports = __webpack_public_path__ + "res/33-img_card_bg_1.ba0f5b24cdd1f9c229bf0f241641ecba.png";